import type { Article } from '~/types/article'

export const articleTopics = [
  'All topics',
  'Cypress',
  'Playwright',
  'AI',
  'Testing',
  'Career'
] as const
export type ArticleTopic = (typeof articleTopics)[number]

export function articleTopic(article: Pick<Article, 'tags' | 'title'>): ArticleTopic {
  const tags = (article.tags || []).map((tag) => tag.toLowerCase().replace(/a\.i\./g, 'ai'))
  const title = article.title.toLowerCase().replace(/a\.i\./g, 'ai')
  if (
    tags.some((tag) => /^(ai|a\.i\.|a\.i|agents?|webmcp|cursor|llm|claude)$/.test(tag)) ||
    /\b(ai|agents?|llm|webmcp|cursor|claude)\b/.test(title)
  )
    return 'AI'
  if (tags.includes('playwright') || title.includes('playwright')) return 'Playwright'
  if (tags.includes('cypress') || title.includes('cypress')) return 'Cypress'
  if (tags.some((tag) => ['career', 'personal', 'learnings'].includes(tag))) return 'Career'
  return 'Testing'
}
